<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}<span class="page_title_value">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                    <v-row>
                        <v-col cols="12" sm="7" md="7" class="pb-n5" v-if="!this.formData.lockstaff">
                            <v-autocomplete
                                outlined
                                :label="this.$t('setupeis.eisgroup')"
                                type="text"
                                dense
                                v-model="formData.eisid"
                                :items="eisGroupList"
                                @change="changeEISGroupHandler(formData.eisid)"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="7" md="7" class="pb-n5" v-else>
                            <v-autocomplete
                                outlined
                                :label="this.$t('setupeis.eisgroup')"
                                type="text"
                                dense
                                v-model="formData.eisid"
                                :items="eisGroupList"
                                background-color="#ffeab2"
                                readonly
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="1" sm="1" class="pb-n5">
                            <v-dialog v-model="eisgroupDialog" max-width="600px" persistent>
                                <template v-slot:activator="{ on }">
                                    <v-btn dense v-on="on">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <app-genericform 
                                        v-bind:parentData = "{
                                            tabItems: eisGroupItems,
                                            formTitle: `${this.$t('setupeis.eisgroupsetup')}`,
                                            formId: 'eisgroupsetup'
                                        }"

                                        v-on:input="itemData = $event"
                                        v-on:saveEISGroup="saveEISGroupHandler"
                                        v-on:deleteEISGroup="deleteEISGroupHandler"
                                    />

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="warning"
                                            text
                                            @click="eisgroupDialog = false"
                                        >
                                            {{$t('button.close')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                background-color="#ffeab2"
                                readonly
                                :label="this.$t('columns.description')"
                                type="text"
                                :rules="[rules.required]"
                                v-model="formData.eisdesc"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.effectivefrom')"
                                type="date"
                                ref="startdate"
                                :rules="[rules.required]"
                                v-model="formData.startdate"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.effectiveuntil')"
                                type="date"
                                ref="enddate"
                                :rules="[rules.required]"
                                v-model="formData.enddate"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n mt-n8">
                            <v-textarea
                                outlined
                                :label="this.$t('columns.remark')"
                                type="text"
                                v-model="formData.remark"
                                @input="updateValue"
                                dense
                            ></v-textarea>
                        </v-col>
                    </v-row>

                    <v-row>
                        <app-table 
                            v-bind:parentObject = "{
                                tabHeader: this.tabHeader,
                                detailItem: this.formData.eisdetails
                            }"

                            v-on:input="addItemHandler"
                        />

                    </v-row>

                </v-container>

                <div v-if="isErr">
                    <app-error
                        v-bind:parentError="{
                            data: this.errMsg,
                            isErr: this.isErr
                        }"
                        v-on:closeError="isErr = $event"
                    />
                </div>

                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.isEdit

                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler" 
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler" />

            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';
import GenericForm from '../../generic/GridForm';
import ErrorDialog from "../../common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-table': CRUDTable,
        'app-genericform': GenericForm,
        'app-error': ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                eisid : this.parentObject.data.eisid,
                eiscode: this.parentObject.data.eiscode,
                eisdesc: this.parentObject.data.eisdesc,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                remark: this.parentObject.data.remark,
                eisdetails: this.parentObject.data.eisdetails,
                lockstaff: this.parentObject.data.lockstaff,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '120px', sortable: false},
                { text: this.$t('setupsocso.uptowages'), value: 'wagesamt', width: '200px', sortable: true},
                { text: this.$t('setupepf.eeamount'), value: 'eeamt', width: '150px', sortable: true},
                { text: this.$t('setupepf.eramount'), value: 'eramt', width: '150px', sortable: true}
            ],

            selected: [],
            affectItems: [],
            eisGroupList: [],
            eisGroupItems: [],
            eisGroup: [],

            eisgroupDialog: false,
            errMsg: '',
            isErr: false,
            isEdit: this.parentObject.isEdit,
             search: this.parentObject.searchnew
        }
    },

    methods: {

        loadEISGroupListHandler() {
            const vm = this;

            this.$store.dispatch('get', {
                url: '/eis/all'})
                .then(res => {
                    vm.eisGroup = res.data.rec;
                    console.log('eisgroup', vm.eisGroup)

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.eisGroupList.push(
                            {
                                text: res.data.rec[i].eiscode,
                                value: res.data.rec[i].id
                            }
                        )

                        vm.eisGroupItems.push(
                            {
                                id: res.data.rec[i].id,
                                code: res.data.rec[i].eiscode,
                                desc: res.data.rec[i].eisdesc,
                                stamp: res.data.rec[i].stamp
                            }
                        )
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },
        
        addItemHandler($event) {
            this.formData.eisdetails=$event

            this.updateValue();
        },

        updateValue() {
            this.$emit('input', {
                eisid : this.formData.eisid,
                eiscode: this.formData.eiscode,
                eisdesc: this.formData.eisdesc,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                remark: this.formData.remark,
                eisdetails: this.formData.eisdetails,
                lockstaff: this.formData.lockstaff,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },

        saveEISGroupHandler() {
            const vm = this;
            console.log('itemid', this.itemData.itemid)

            if (this.itemData.itemid) {
                this.$store.dispatch('put', {
                    url: '/eis/' + this.itemData.itemid, 
                    payload: {
                        eiscode: this.itemData.itemcode,
                        eisdesc: this.itemData.itemdesc,
                        stamp: this.itemData.itemstamp,
                        userid: this.formData.userid
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.eisGroup = [];
                        vm.eisGroupItems = [];
                        vm.eisGroupList = [];

                        this.loadEISGroupListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            } else {
                this.$store.dispatch('post', {
                    url: '/eis/create', 
                    payload: {
                        eiscode: this.itemData.itemcode,
                        eisdesc: this.itemData.itemdesc,
                        userid: this.formData.userid
                }})
                .then(res => {
                    console.log('res', res)
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.eisGroup = [];
                        vm.eisGroupItems = [];
                        vm.eisGroupList = [];

                        this.loadEISGroupListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        console.log('err', vm.errMsg)
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        deleteEISGroupHandler($event) {
            const vm = this;

            if (confirm('Remove ' + $event.desc + '?')) {
                this.$store.dispatch('delete', {
                    url: '/eis/' + $event.id + '/' + this.formData.userid})
                .then(res => {
                    if (res.data.status == 200) {
                        // resets all arrays
                        vm.eisGroup = [];
                        vm.eisGroupItems = [];
                        vm.eisGroupList = [];

                        this.loadEISGroupListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });                
            }

        },

        changeEISGroupHandler(id) {
            let item = this.eisGroup.find(item => item.id === parseInt(id));
            
            this.formData.eiscode = item.eiscode;
            this.formData.eisdesc = item.eisdesc;
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'eislist', params: { search: this.search}});
        },

        closeHandler() {
            this.subDialog = false;
            this.isErr = !this.isErr;
            this.errMsg = '';
        }
    },

    mounted() {
        this.loadEISGroupListHandler();
        if (this.parentObject.isEdit){
            this.duplicateStaffData = this.formData;
            
            if (this.parentObject.data.lockstaff == "N") {
                this.formData.lockstaff = false;
            } else {
                this.formData.lockstaff = true;
            }
        }
    }
}
</script>